import { MenuItem, SelectChangeEvent } from "@mui/material";
import { CustomSelect } from "../custom_select/CustomSelect";

interface DropDownSelectProperties {
  label: string;
  values: any[];
  value: any | undefined;
  displayMember: string;
  onChange?: (event: SelectChangeEvent<any>, child: React.ReactNode) => void;
  children?: React.ReactNode;
}

export function DropDownSelect(properties: DropDownSelectProperties) {

  const options = properties.values.map((x, index) => {
    return <MenuItem key={index} value={x}>{x[properties.displayMember]}</MenuItem>
  });
  return (
    <CustomSelect
      label={properties.label}
      value={properties.value}
      onChange={properties.onChange}
    >
      {options}
    </CustomSelect>
  );
}
